import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from 'semantic-ui-react';

import {
  ManagementStep,
  RegistrationMethod,
  StaffExcelUpload,
  ExcelStaffList
} from 'components/StaffManagementByExcel';
import { Commons } from 'components';
import * as com_action from 'actions/company';

import toastr from 'helpers/toastr';
import cm from 'helpers/commons';

class StaffManagementByExcel extends Component {
  constructor() {
    super();
    this.state = {
      step: 1,
      method: 'reg', // reg(신규), upd(수정), del(탈퇴)

      groupNum: 0,
      groupName: '',

      file: null,
      tableResult: null,
      isLoading: false,
      employeeAuth: cm.authGroupSet('employee')
    };
  }

  componentWillMount() {
    const { employeeAuth } = this.state;

    if (employeeAuth.all || employeeAuth.create) {
      this.setState({ method: 'reg' });
    } else if (employeeAuth.update) {
      this.setState({ method: 'upd' });
    } else if (employeeAuth.delete) {
      this.setState({ method: 'del' });
    }
  }

  componentDidMount() {
    cm.mainTitle('사용자 목록 > 엑셀파일로 관리하기');
  }

  // 등록 방식 선택
  methodSel = (e, { value }) => {
    this.setState({ method: value });
  };

  // 이전
  prevStep = () => {
    const { step } = this.state;

    if (step === 2) {
      this.setState({
        step: 1,
        // method: 'reg',
        groupNum: 0,
        groupName: '',
        file: null,
        tableResult: null
      });
    } else if (step === 3) {
      this.setState({ step: 2 });
    }
  };

  // 다음, 완료, 추가등록하기
  nextStep = async () => {
    const { step } = this.state;
    $('.staff-excel').scrollTop(0);
    await this.setState({ isLoading: true });
    if (step === 1) {
      await this.setState({
        step: 2
      });
    } else if (step === 2) {
      const { method, groupNum, tableResult } = this.state;

      if (method === 'reg' && (!groupNum || groupNum <= 0)) {
        toastr('top-right', 'warning', '식대 그룹을 선택해주세요.');
      } else if (!(tableResult && tableResult.data)) {
        toastr('top-right', 'warning', '엑셀파일을 업로드 해주세요.');
      } else if (tableResult.data.count.fail > 0) {
        toastr('top-right', 'warning', '실패항목이 있습니다. 엑셀파일에서 정보 수정 후 다시 업로드 해주세요.');
      } else {
        await this.setState({ step: 3 });
      }
    } else if (step === 3) {
      alert(
        '엑셀로 사용자 정보를 업데이트 하는 요청은 시스템 상황에 따라 실시간으로 반영되지 않을 수 있습니다. 약 10분 후에도 반영이 안되어 있다면, 식권대장에 문의 바랍니다.'
      );
      await this.uploadStaffList();
      await this.setState({
        step: 4
        // tableResult : null
      });
    } else if (step === 4) {
      await this.setState({
        step: 1,
        method: 'reg',
        groupNum: 0,
        groupName: '',
        file: null,
        tableResult: null
      });
    }
    await this.setState({ isLoading: false });
  };

  // 식대 그쿱 클릭
  sikdaeGroupClick = (group, name) => {
    this.setState({
      groupNum: group,
      groupName: name
    });
  };

  // 체크한 업로드 위한 파일 데이터 저장
  setFileData = async (file, excelList) => {
    await this.setState({
      tableResult: excelList,
      file
    });
  };

  uploadStaffList = async () => {
    const { file } = this.state;
    const { comAPI } = this.props;

    const formData = file;
    const { method, groupNum, groupName } = this.state;

    formData.append('groupidx', groupNum);
    formData.append('groupname', groupName);
    formData.append('viewType', 'all');

    try {
      this.setState({
        isLoading: true
      });

      await comAPI.StaffExcelUpload(formData);

      this.setState({ isLoading: false });
    } catch (e) {
      toastr('top-right', 'error', '처리 중 오류가 발생했습니다. 다시 시도해주세요.');
    }
  };

  moveToStaffManagement = () => {
    location.href = '/main/staffManagement';
    // this.context.router.history.push('/main/staffManagement');
  };

  excelUpload = async (formData) => {
    const { comAPI } = this.props;

    await this.setState({ isLoading: true });

    try {
      const { method, groupNum, groupName } = this.state;

      formData.append('functype', method);
      await comAPI.staffExcelCheck(formData);
      this.setState({
        isLoading: false,
        tableResult: null
      });

      const { excelCheck } = this.props;

      if (excelCheck) {
        this.setFileData(formData, excelCheck);
      }
    } catch (e) {
      this.setState({ isLoading: false });
      const { response } = e;
      if (response) {
        toastr('top-right', 'error', response.data.message);
      }

      console.log('###### excelUpload error : ', e);
    } finally {
    }
  };

  render() {
    const { step, method, groupNum, groupName, tableResult, isLoading } = this.state;
    const StepFn = {
      activeStep: step
    };
    const RegMethodFn = {
      activeStep: step,
      method,
      methodSel: this.methodSel
    };
    const ExcelFn = {
      activeStep: step,
      method,
      groupNum,
      groupName,
      sikdaeGroupClick: this.sikdaeGroupClick,
      setFileData: this.setFileData,
      excelUpload: this.excelUpload
    };
    const StaffExcelFn = {
      activeStep: step,
      method,
      tableResult
    };

    let bottomRightBtnTxt = '다음';
    let bottomRightBtnColor = 'green';
    if (step === 3) {
      if (method === 'del') {
        bottomRightBtnTxt = '퇴사처리';
        bottomRightBtnColor = 'red';
      } else {
        bottomRightBtnTxt = '완료';
      }
    }

    return (
      <main className="staff-excel">
        {/* 단계 */}
        <ManagementStep StepFn={StepFn} />

        <div className="body-content">
          {step < 4 ? <RegistrationMethod RegMethodFn={RegMethodFn} /> : ''}
          {step > 1 && step < 4 ? <StaffExcelUpload ExcelFn={ExcelFn} /> : ''}
          {step > 1 ? isLoading ? <Commons.LoadingBar /> : <ExcelStaffList StaffExcelFn={StaffExcelFn} /> : ''}
        </div>

        {step <= 3 ? (
          <div className="bottom-btns">
            <Button inverted color="red" className="cancel" onClick={this.moveToStaffManagement}>
              취소
            </Button>
            {step === 1 ? (
              ''
            ) : (
              <Button inverted color="black" onClick={this.prevStep}>
                이전
              </Button>
            )}
            <Button color={bottomRightBtnColor} className="next" onClick={this.nextStep}>
              {bottomRightBtnTxt}
            </Button>
          </div>
        ) : (
          <div className="bottom-btns align-center">
            <Button inverted color="black" onClick={this.moveToStaffManagement}>
              사용자 목록 확인
            </Button>
            <Button inverted color="black" onClick={this.nextStep}>
              추가 등록하기
            </Button>
          </div>
        )}
      </main>
    );
  }
}

StaffManagementByExcel.contextTypes = {
  router: PropTypes.object.isRequired
};

StaffManagementByExcel = connect(
  (state) => ({
    excelCheck: state.company.staff_excel_check,
    excelUpload: state.company.staff_excel_upload
  }),
  (dispatch) => ({
    comAPI: bindActionCreators(
      {
        StaffExcelUpload: com_action.StaffExcelUpload,
        staffExcelCheck: com_action.StaffExcelCheck
      },
      dispatch
    )
  })
)(StaffManagementByExcel);

export default StaffManagementByExcel;
